import { render, staticRenderFns } from "./base-input-text.vue?vue&type=template&id=177495c1&"
import script from "./base-input-text.vue?vue&type=script&lang=js&"
export * from "./base-input-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports